import { get, put } from '../utils/axios'

export const getWelfarePVDAPI = async (param) => {
  return await get('welfares/pvds', param)
}

export const updatePVDAPI = async (param, body) => {
  return await put('pvds', param, body)
}

export const getWelfareAPI = async (param) => {
  return await get('welfares', param)
}



